import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { applicationActions } from "../store/application-slice";
import { useEffect } from "react";
import { setStudyGroup } from "../store/topic-actions";
import { checkLogin } from "../store/auth-actions";
import { fetchCurriculumData } from "../store/curriculum-actions";
import classes from "./Layout.module.css"
import goToComputer from '../assests/go-to-computer.png';
import DynamicMessage from "./lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "./lms-shared/models/DynamicMessageTypeEnum";

const Layout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { applictionName, studyGroupId } = useParams();
  const { curriculums } = useSelector(state => state.curriculums);
  const { studyGroup } = useSelector(state => state.topics);
  const uiData = useSelector((state) => state.general.uiData);
  const texts = useSelector((state) => state.translate.texts);
  const [messagePopUp, setMessagePopup] = useState()
  const { homeUrl, applicationId, colorsChanges } = useSelector(state => state.application);
  const { direction } = useSelector((state) => state.translate);

  useEffect(() => {
    if (uiData) {
      fetchCurriculumAndApplicationData()
    }
  }, [dispatch, texts, uiData])

  useEffect(() => {
    if (applicationId) {
      dispatch(fetchCurriculumData(MessageCB))
    }
  }, [applicationId])

  const fetchCurriculumAndApplicationData = async () => {
    await dispatch(applicationActions.setInitial({ applictionName, uiData }))
  };

  const changeColors = () => {
    if(colorsChanges){
      document.documentElement.style.setProperty('--main-color', colorsChanges.mainColor);
      document.documentElement.style.setProperty('--messages-color', colorsChanges.messagesColor);
      document.documentElement.style.setProperty('--icons-color', colorsChanges.iconsColor);
      document.documentElement.style.setProperty('--level-name-color', colorsChanges.levelName);
      document.documentElement.style.setProperty('--icon-text-color', colorsChanges.iconTextColor);
    }
  };

  useEffect(() => {
    dispatch(checkLogin(applictionName));
  }, [dispatch, texts])

  useEffect(() => {
    if (uiData && homeUrl) {
      if (curriculums?.length > 0 && studyGroupId && studyGroup?.id !== studyGroupId && applicationId) {
        dispatch(setStudyGroup(studyGroupId, navigate, MessageCB, uiData, location))
      }
      changeColors()
    }
  }, [curriculums, studyGroupId, uiData, homeUrl, applicationId])

  const MessageCB = () => {
    if (homeUrl && location.pathname != homeUrl)
      setMessagePopup(<DynamicMessage
        type={DynamicMessageTypeEnum.Warn}
        title={texts.noPermissionTitle}
        content={texts.noPermissionToEnterStudyGroup}
        confirmText={texts.iUnderstand}
        confirmFunc={() => MessageCBConfirmFunc()}
        showCancel={false} />)
  }

  const MessageCBConfirmFunc = () => {
    setMessagePopup(null)
    navigate(homeUrl)
  }

  return (
    <div className={direction}>
      {messagePopUp}
      <div className={classes.GoToComputerWrapper}>
        <div className={classes.GoToComputerBackground}></div>
        <div className={classes.GoToComputerContent}>
          <img src={goToComputer} className={classes.GoToComputerImg} alt="GoToComputerIcon" />
          <div className={classes.GoToComputerText}>{texts.siteOnComputer}</div>
        </div>
      </div>
      <div className={classes.ResponsiveComputerWrapper}>
        <Outlet ></Outlet>
      </div>
    </div>
  )

}
export default Layout;